/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from "react";
import moment from "moment";
import "moment/locale/es";

const InfoDoc = (props) => {
  moment.locale("es");

  return (
    <div data-testid="spaceListTxInfo" className="dataBlock">
      {props.content.data.cards && props.content.data.cards.map((item, index) => {
          if (index == 0) {
            return (
              <div className="dataBlockItem" key={`block-${index}`}>
                <label className="neutral" style={{width: "23.5%"}}>Customers</label>
                <p>{item}</p>
              </div>
            );
          } else {
            return (
              <div className="dataBlockItem" key={`block-${index}`}>
                <label className="neutral" style={{width: "23.5%"}}></label>
                <p>{item}</p>
              </div>
            );
          }
        })}
      {props.content.data.cdate && (
        <div className="dataBlockItem">
          <label className="neutral" style={{width: "23.5%"}}>Fecha de creación</label>
          <p>
            {props.content.data.cdate? moment(props.content.data.cdate).format("LLL") : ""}
          </p>
        </div>
      )}
    </div>
  );
};

export default InfoDoc;
